<template>
  <div id='map' class='flex items-center z4'>
    <div id='map-top' class='relative flex justify-between py2 md-py3 px2 md-px4 z4'>
      <div id='top-left' class='flex-grow'>
        <span class="xs-hide sm-hide">224 Greene Ave, Brooklyn, 11238</span>
        <span class="md-hide lg-hide">224 Greene Ave,<br/>Brooklyn, 11238</span>
      </div>
      <div id='top-right' class='flex-grow'><a href="https://www.google.com/maps/dir/''/224+Greene+Ave,+Brooklyn,+NY+11238/@40.6869631,-73.9642633,17z/data=!3m1!4b1!4m8!4m7!1m0!1m5!1m1!1s0x89c25bbdcc01671b:0x1d215fcd4dcd9857!2m2!1d-73.9620746!2d40.6869631" target='_blank'>Directions</a></div>
    </div>
    <div id='map-content' class='center'>
      <div>
        <GmapMap
          :center='{lat:40.6874, lng:-73.9620746}'
          :zoom='17'
          :marker='{}'
          :options='{styles: mapStyles, disableDefaultUI: true}'
          map-type-id='terrain'
          style='width: 100vw; height: 100vh'
        >
          <GmapMarker :position='{lat:40.6869631, lng:-73.9620746}' :icon="`${baseUrl}dot.svg`"></GmapMarker>
          <GmapMarker :animation=1 :position='{lat:40.6869631, lng:-73.9620746}' :icon="`${baseUrl}finger.svg`"></GmapMarker>
        </GmapMap>
      </div>
    </div>
    <div id='map-bottom' class='flex justify-between py2 md-py3 px2 md-px4'>
      <div id='bottom-left' class='flex-grow'><router-link to="/">Go Back</router-link></div>
      <div id='bottom-right' class='flex-grow'>
        <span class="xs-hide sm-hide">Between Grand and Classon</span>
        <span class="md-hide lg-hide">Btwn. Grand Classon</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'Hours',

  data () {
    return {
      baseUrl: process.env.BASE_URL,
      mapStyles: [
        {
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        },
        {
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#6d6d6d'
            }
          ]
        },
        {
          'elementType': 'labels.text.stroke',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative',
          'elementType': 'geometry',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'administrative.land_parcel',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#bdbdbd'
            }
          ]
        },
        {
          'featureType': 'landscape',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'poi.park',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#e5e5e5'
            }
          ]
        },
        {
          'featureType': 'poi.park',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#9e9e9e'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#f5f5f5'
            }
          ]
        },
        {
          'featureType': 'road',
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'transit',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        },
        {
          'featureType': 'transit.line',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#e5e5e5'
            }
          ]
        },
        {
          'featureType': 'transit.station',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#eeeeee'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#c9c9c9'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#FF0000'
            }
          ]
        },
        {
          'featureType': 'water',
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'color': '#9e9e9e'
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<style>
  #map {
    background: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: black;

    a {
      color: black;
    }

    #map-top {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
    }

    #map-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
    }

    #map-content {
      line-height: 1.2;
    }
  }
</style>
